import React from "react";
import * as XLSX from "xlsx";
import ImportadorExcelGenerico from "../../../../../Components/ImportadorExcelGenerico";
import { encodeId, decodeId } from "../../../../../Components/idEncoder";

const columnasPreview = [
  { title: "Nombre", dataIndex: "nombre", key: "nombre", width: 180 },
  {
    title: "Escuela",
    dataIndex: "escuelaNombre",
    key: "escuelaNombre",
    width: 200,
  },
  { title: "Grado", dataIndex: "grado", key: "grado", width: 100 },
  {
    title: "Nivel Educativo",
    dataIndex: "nivelEducativoNombre",
    key: "nivelEducativoNombre",
    width: 180,
  },
  {
    title: "Programa Educativo",
    dataIndex: "programaEducativoNombre",
    key: "programaEducativoNombre",
    width: 200,
  },
  // { title: "Lista", dataIndex: "listaNombre", key: "listaNombre", width: 180 },
];

const construirPlantilla = (catalogos) => {
  const wb = XLSX.utils.book_new();

  const escuelaEjemplo = catalogos.escuelas?.[0]?.nombre || "";
  const nivelEjemplo = catalogos.niveles?.[0]?.nombre || "";
  const programaEjemplo = catalogos.programas?.[0]?.nombre || "";
  // const listaEjemplo = catalogos.listas?.[0]?.nombre || "";

  const ejemplos = [
    {
      ID: "",
      Nombre: "Grupo A",
      Escuela: escuelaEjemplo,
      Grado: "1",
      "Nivel Educativo": nivelEjemplo,
      "Programa Educativo": programaEjemplo,
      // Lista: listaEjemplo,
    },
  ];
  const hojaPrincipal = XLSX.utils.json_to_sheet(ejemplos, {
    header: [
      "ID",
      "Nombre",
      "Escuela",
      "Grado",
      "Nivel Educativo",
      "Programa Educativo",
      // "Lista",
    ],
  });
  hojaPrincipal["!cols"] = [
    { wch: 20 },
    { wch: 18 },
    { wch: 28 },
    { wch: 10 },
    { wch: 22 },
    { wch: 28 },
    // { wch: 28 },
  ];
  XLSX.utils.book_append_sheet(wb, hojaPrincipal, "Grupos");

  const hoja = (titulo, datos) => {
    const filas =
      datos.length > 0
        ? datos
        : [{ Nombre: `(no hay ${titulo.toLowerCase()} registrados)` }];
    const sh = XLSX.utils.json_to_sheet(filas);
    const columnas = Object.keys(filas[0] || {});
    sh["!cols"] = columnas.map(() => ({ wch: 24 }));
    XLSX.utils.book_append_sheet(wb, sh, titulo);
  };

  hoja(
    "Escuelas",
    (catalogos.escuelas || []).map((e) => ({
      Clave: e.clave || "",
      Nombre: e.nombre,
    })),
  );
  hoja(
    "Niveles",
    (catalogos.niveles || []).map((n) => ({ Nombre: n.nombre })),
  );
  hoja(
    "Programas",
    (catalogos.programas || []).map((p) => ({ Nombre: p.nombre })),
  );
  // hoja(
  //   "Listas",
  //   (catalogos.listas || []).map((l) => ({ Nombre: l.nombre })),
  // );

  const escuelaNombrePorId = new Map(
    (catalogos.escuelas || []).map((e) => [String(e._id), e.nombre || ""]),
  );
  const nivelNombrePorId = new Map(
    (catalogos.niveles || []).map((n) => [String(n._id), n.nombre || ""]),
  );
  const programaNombrePorId = new Map(
    (catalogos.programas || []).map((p) => [String(p._id), p.nombre || ""]),
  );
  // const listaNombrePorId = new Map(
  //   (catalogos.listas || []).map((l) => [String(l._id), l.nombre || ""]),
  // );
  const existentes = (catalogos.grupos || []).map((g) => ({
    ID: encodeId(String(g._id)),
    Nombre: g.nombre || "",
    Escuela: escuelaNombrePorId.get(String(g.escuelaId)) || "",
    Grado: g.grado !== undefined && g.grado !== null ? String(g.grado) : "",
    "Nivel Educativo":
      nivelNombrePorId.get(String(g.nivelEducativoId)) || "",
    "Programa Educativo":
      programaNombrePorId.get(String(g.programaEducativoId)) || "",
    // Lista: listaNombrePorId.get(String(g.listaId)) || "",
    Estado: g.estado === 1 ? "Activo" : "Deshabilitado",
  }));
  hoja(
    "Existentes",
    existentes.length > 0
      ? existentes
      : [{ Nombre: "(no hay grupos registrados)" }],
  );

  return wb;
};

const idStr = (v) => {
  if (!v) return "";
  if (typeof v === "object" && v._id) return String(v._id);
  return String(v);
};

const validarFila = (fila, catalogos, _indice, contexto) => {
  const errores = [];
  const nombre = fila["Nombre"] ? String(fila["Nombre"]).trim() : "";
  const escuelaNombre = fila["Escuela"] ? String(fila["Escuela"]).trim() : "";
  const grado = fila["Grado"] !== undefined ? String(fila["Grado"]).trim() : "";
  const nivelNombre = fila["Nivel Educativo"]
    ? String(fila["Nivel Educativo"]).trim()
    : "";
  const programaNombre = fila["Programa Educativo"]
    ? String(fila["Programa Educativo"]).trim()
    : "";
  // const listaNombre = fila["Lista"] ? String(fila["Lista"]).trim() : "";
  const idEncoded = fila["ID"] ? String(fila["ID"]).trim() : "";

  if (!nombre) errores.push({ campo: "Nombre", motivo: "está vacío" });
  if (!escuelaNombre)
    errores.push({ campo: "Escuela", motivo: "está vacío (obligatorio)" });

  let escuelaId = null;
  let escuelaResuelta = null;
  if (escuelaNombre) {
    const llave = escuelaNombre.toLowerCase();
    escuelaResuelta =
      (catalogos.escuelas || []).find(
        (e) => (e.clave || "").trim().toLowerCase() === llave,
      ) ||
      (catalogos.escuelas || []).find(
        (e) => (e.nombre || "").trim().toLowerCase() === llave,
      );
    if (!escuelaResuelta) {
      errores.push({
        campo: "Escuela",
        motivo: `"${escuelaNombre}" no existe (puedes usar la clave o el nombre — revisa la hoja "Escuelas")`,
      });
    } else {
      escuelaId = escuelaResuelta._id;
    }
  }

  // Resolver existente: prioridad por ID si viene, si no por tupla (escuelaId, nombre).
  let existente = null;
  if (idEncoded) {
    const decoded = decodeId(idEncoded);
    if (!decoded) {
      errores.push({ campo: "ID", motivo: `"${idEncoded}" no es válido` });
    } else {
      existente = (catalogos.grupos || []).find(
        (g) => String(g._id) === String(decoded),
      );
      if (!existente) {
        errores.push({
          campo: "ID",
          motivo: `"${idEncoded}" no corresponde a ningún grupo existente`,
        });
      }
    }
  } else if (nombre && escuelaId) {
    existente =
      (catalogos.grupos || []).find(
        (g) =>
          String(g.escuelaId) === String(escuelaId) &&
          (g.nombre || "").trim().toLowerCase() === nombre.toLowerCase(),
      ) || null;
  }

  // Duplicados dentro del archivo por tupla.
  if (nombre && escuelaId) {
    const llaveTupla = `${String(escuelaId)}|${nombre.toLowerCase()}`;
    if (contexto.clavesYaUsadas.has(llaveTupla)) {
      errores.push({
        campo: "Nombre",
        motivo: `combinación escuela+nombre repetida (también en la fila ${contexto.clavesYaUsadas.get(llaveTupla)})`,
      });
    } else {
      contexto.clavesYaUsadas.set(llaveTupla, (fila["__rowNum__"] ?? 0) + 1);
    }
  }

  // Si hay existente por ID pero la tupla (escuelaId, nombre) coincide con otro grupo distinto, es conflicto.
  if (existente && nombre && escuelaId) {
    const conflicto = (catalogos.grupos || []).find(
      (g) =>
        String(g._id) !== String(existente._id) &&
        String(g.escuelaId) === String(escuelaId) &&
        (g.nombre || "").trim().toLowerCase() === nombre.toLowerCase(),
    );
    if (conflicto) {
      errores.push({
        campo: "Nombre",
        motivo: "ya existe otro grupo con ese nombre en esa escuela",
      });
    }
  }

  let nivelEducativoId = null;
  let nivelResuelto = null;
  if (nivelNombre) {
    const llave = nivelNombre.toLowerCase();
    nivelResuelto = (catalogos.niveles || []).find(
      (n) => (n.nombre || "").trim().toLowerCase() === llave,
    );
    if (!nivelResuelto) {
      errores.push({
        campo: "Nivel Educativo",
        motivo: `"${nivelNombre}" no existe`,
      });
    } else {
      nivelEducativoId = nivelResuelto._id;
    }
  }

  let programaEducativoId = null;
  let programaResuelto = null;
  if (programaNombre) {
    const llave = programaNombre.toLowerCase();
    programaResuelto = (catalogos.programas || []).find(
      (p) => (p.nombre || "").trim().toLowerCase() === llave,
    );
    if (!programaResuelto) {
      errores.push({
        campo: "Programa Educativo",
        motivo: `"${programaNombre}" no existe`,
      });
    } else {
      programaEducativoId = programaResuelto._id;
    }
  }

  // let listaId = null;
  // let listaResuelta = null;
  // if (listaNombre) {
  //   const llave = listaNombre.toLowerCase();
  //   listaResuelta = (catalogos.listas || []).find(
  //     (l) => (l.nombre || "").trim().toLowerCase() === llave,
  //   );
  //   if (!listaResuelta) {
  //     errores.push({
  //       campo: "Lista",
  //       motivo: `"${listaNombre}" no existe (revisa la hoja "Listas")`,
  //     });
  //   } else {
  //     listaId = listaResuelta._id;
  //   }
  // }

  if (errores.length > 0) {
    return { ok: false, errores };
  }

  const datos = {
    nombre,
    escuelaId,
    escuelaNombre: escuelaResuelta?.nombre || "",
    grado,
    nivelEducativoId,
    nivelEducativoNombre: nivelResuelto?.nombre || "",
    programaEducativoId,
    programaEducativoNombre: programaResuelto?.nombre || "",
    // listaId,
    // listaNombre: listaResuelta?.nombre || "",
  };

  if (!existente) {
    return { ok: true, accion: "crear", datos };
  }

  // Construir valores anteriores y detectar cambios.
  const escuelaPrev = (catalogos.escuelas || []).find(
    (e) => String(e._id) === idStr(existente.escuelaId),
  );
  const nivelPrev = (catalogos.niveles || []).find(
    (n) => String(n._id) === idStr(existente.nivelEducativoId),
  );
  const programaPrev = (catalogos.programas || []).find(
    (p) => String(p._id) === idStr(existente.programaEducativoId),
  );
  // const listaPrev = (catalogos.listas || []).find(
  //   (l) => String(l._id) === idStr(existente.listaId),
  // );

  const valoresAnteriores = {
    nombre: (existente.nombre || "").trim(),
    escuelaNombre: escuelaPrev?.nombre || "",
    grado: (existente.grado || "").trim?.() ?? String(existente.grado || ""),
    nivelEducativoNombre: nivelPrev?.nombre || "",
    programaEducativoNombre: programaPrev?.nombre || "",
    // listaNombre: listaPrev?.nombre || "",
  };

  const cambios = [];
  if (valoresAnteriores.nombre !== nombre) cambios.push("nombre");
  if (idStr(existente.escuelaId) !== String(escuelaId))
    cambios.push("escuelaNombre");
  if (valoresAnteriores.grado !== grado) cambios.push("grado");
  if (idStr(existente.nivelEducativoId) !== String(nivelEducativoId || ""))
    cambios.push("nivelEducativoNombre");
  if (
    idStr(existente.programaEducativoId) !== String(programaEducativoId || "")
  )
    cambios.push("programaEducativoNombre");
  // if (idStr(existente.listaId) !== String(listaId || ""))
  //   cambios.push("listaNombre");

  if (cambios.length === 0) {
    return {
      ok: true,
      accion: "sinCambios",
      idExistente: String(existente._id),
      datos,
      valoresAnteriores,
    };
  }

  return {
    ok: true,
    accion: "editar",
    idExistente: String(existente._id),
    datos,
    cambios,
    valoresAnteriores,
  };
};

const instrucciones = [
  <>
    <b>Descarga la plantilla.</b> El archivo trae varias hojas:
    <ul style={{ marginTop: 4, marginBottom: 0, paddingLeft: 18 }}>
      <li>
        <b>Grupos</b> — la hoja principal donde escribes los datos a importar.
      </li>
      <li>
        <b>Existentes</b> — contiene tus grupos actuales con todos sus datos
        (Nombre, Escuela, Grado, Nivel Educativo, Programa Educativo).
        Cópialos a la hoja <b>Grupos</b> si quieres editarlos.
      </li>
      <li>
        <b>Escuelas, Niveles, Programas</b> — catálogos de referencia
        para que sepas qué valores son válidos.
      </li>
    </ul>
  </>,
  <>
    Para <b>crear</b> un grupo: deja la columna <b>ID</b> vacía y llena el
    resto.
  </>,
  <>
    Para <b>editar</b> un grupo: copia su fila desde la hoja{" "}
    <b>Existentes</b> a la hoja <b>Grupos</b> (con el ID incluido) y modifica
    los campos que quieras cambiar.
  </>,
  <>
    Sube el archivo modificado. Verás un resumen de cuántas filas se van a
    crear, a editar o no tienen cambios.
  </>,
  <>
    Si hay errores, podrás descargar <code>errores.xlsx</code> para revisarlos.
  </>,
  <>
    En la tabla de vista previa, las filas a <b>Editar</b> muestran el valor
    nuevo y debajo, en gris tachado, el valor anterior.
  </>,
  <>
    Haz clic en <b>Importar</b> para aplicar los cambios.
  </>,
];

const ImportarGrupos = (props) => (
  <ImportadorExcelGenerico
    {...props}
    titulo="Importar / Actualizar Grupos"
    nombreEntidadPlural="grupos"
    endpointDatosImportar="gruposEscuela/datosParaImportarGrupos"
    endpointImportar="gruposEscuela/importarGrupos"
    nombrePlantilla="plantillaGrupos.xlsx"
    construirPlantilla={construirPlantilla}
    validarFila={validarFila}
    columnasPreview={columnasPreview}
    instrucciones={instrucciones}
    permitirEdicion
    mostrarSwitchSoloCambios
  />
);

export default ImportarGrupos;
